import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** The `ArrayFieldItemTemplate` component is the template used to render an items of an array.
 *
 * @param props - The `ArrayFieldTemplateItemType` props for the component
 */

export default function ArrayFieldItemTemplate(props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      hasToolbar = props.hasToolbar,
      hasMoveDown = props.hasMoveDown,
      hasMoveUp = props.hasMoveUp,
      hasRemove = props.hasRemove,
      hasCopy = props.hasCopy,
      index = props.index,
      onCopyIndexClick = props.onCopyIndexClick,
      onDropIndexClick = props.onDropIndexClick,
      onReorderClick = props.onReorderClick,
      readonly = props.readonly,
      registry = props.registry,
      uiSchema = props.uiSchema;
  var _registry$templates$B = registry.templates.ButtonTemplates,
      CopyButton = _registry$templates$B.CopyButton,
      MoveDownButton = _registry$templates$B.MoveDownButton,
      MoveUpButton = _registry$templates$B.MoveUpButton,
      RemoveButton = _registry$templates$B.RemoveButton;
  var btnStyle = {
    flex: 1,
    paddingLeft: 6,
    paddingRight: 6,
    fontWeight: 'bold'
  };
  return _jsxs("div", {
    className: className,
    children: [_jsx("div", {
      className: hasToolbar ? 'col-xs-9' : 'col-xs-12',
      children: children
    }), hasToolbar && _jsx("div", {
      className: 'col-xs-3 array-item-toolbox',
      children: _jsxs("div", {
        className: 'btn-group',
        style: {
          display: 'flex',
          justifyContent: 'space-around'
        },
        children: [(hasMoveUp || hasMoveDown) && _jsx(MoveUpButton, {
          style: btnStyle,
          disabled: disabled || readonly || !hasMoveUp,
          onClick: onReorderClick(index, index - 1),
          uiSchema: uiSchema,
          registry: registry
        }), (hasMoveUp || hasMoveDown) && _jsx(MoveDownButton, {
          style: btnStyle,
          disabled: disabled || readonly || !hasMoveDown,
          onClick: onReorderClick(index, index + 1),
          uiSchema: uiSchema,
          registry: registry
        }), hasCopy && _jsx(CopyButton, {
          style: btnStyle,
          disabled: disabled || readonly,
          onClick: onCopyIndexClick(index),
          uiSchema: uiSchema,
          registry: registry
        }), hasRemove && _jsx(RemoveButton, {
          style: btnStyle,
          disabled: disabled || readonly,
          onClick: onDropIndexClick(index),
          uiSchema: uiSchema,
          registry: registry
        })]
      })
    })]
  });
}